import { render, staticRenderFns } from "./RoomDecorationRecord.vue?vue&type=template&id=4288027c&scoped=true"
import script from "./RoomDecorationRecord.vue?vue&type=script&lang=js"
export * from "./RoomDecorationRecord.vue?vue&type=script&lang=js"
import style0 from "./RoomDecorationRecord.vue?vue&type=style&index=0&id=4288027c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288027c",
  null
  
)

export default component.exports